import React from "react";
import "./NavBar.css";
import logo from "../../assets/tubev1.png"; // use your current logo

export default function NavBar() {
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src={logo} alt="Logo" className="navbar-logo" />
        <span className="navbar-title">tubestamp</span>
      </div>
      <button className="chatbot-btn">AI Video Chatbot →</button>
    </nav>
  );
}
